import * as React from 'react';

import { HomeDefault } from '@entities/home/home-default';
import { HomeNomad } from '@entities/home/home-nomad';

import { config } from '@/config.ts';

const Home = () => {
	const isNomad = config.BRAND === 'nomad';
	return isNomad ? <HomeNomad /> : <HomeDefault />;
};

export default Home;
